import {Directive, ElementRef, Input, Renderer2} from '@angular/core';

@Directive({
  // autoFocus is a keyword/directive in Angular
  // so we have to preface the "autoFocus" with "oc"
  selector: '[oxAutoFocus]'
})
export class AutoFocusDirective {
  constructor(private renderer: Renderer2, private element: ElementRef) {
  }

  @Input() set oxAutoFocus(val: string) {
    const _val = val.toString();
    // if T/F value is applied to the directive then the change of this value will trigger the focus

    if(_val){
      if (_val === 'true') {
        this.element.nativeElement.focus();
      } else {
        this.element.nativeElement.blur();
      }
    }
    else{
      setTimeout(()=>{
        this.element.nativeElement.focus();
      }, 250);
    }
  }
}
